





























import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from './components/common/CommonHeader.vue';
import CommonMenuNavigationDrawer from './components/common/CommonMenuNavigationDrawer.vue';
import JobHeader from './components/jobList/common/JobHeader.vue';
import { vxm } from '@/store';
// import DirectoryMenuNavigationDrawer from './components/documents/DirectoryMenuNavigationDrawer.vue';

@Component({
  components: {
    CommonHeader,
    CommonMenuNavigationDrawer,
    JobHeader,
    // DirectoryMenuNavigationDrawer,
  },
})
export default class App extends Vue {
  private sideFlag: boolean = false;
  private changeSideFlag(flg: boolean) {
    this.sideFlag = flg;
  }

  /**
   * サイドナビゲーションメニュー開閉であてるCSSを変える関数
   * サイドメニューがないページはpaddingが0
   */
  private sideMenuWidth() {
    if (!this.isMenuNavigationDrawerRequired()) {
      return 'zero-padding';
    }
    return {
      'side-open-padding': !this.sideFlag,
      'side-close-padding': this.sideFlag,
    };
  }

  private isHeaderRequired(): boolean {
    const userInfo = vxm.theoryApi.authStore.getCurrentUserInfo;
    if (
      (userInfo && !this.organizationId) ||
      this.$route.name === 'organizationDashboard' ||
      this.$route.name === 'jobList' ||
      this.$route.name === 'login' ||
      this.$route.name === 'createAccount' ||
      this.$route.name === 'confirmPassword' ||
      this.$route.name === 'confirmSignUp' ||
      this.$route.name === 'joinSelect' ||
      this.$route.name === 'projectJoin' ||
      this.$route.name === 'sendConfirmCode' ||
      this.$route.name === 'myDashboard'
    ) {
      return false;
    }
    return true;
  }

    private isMenuNavigationDrawerRequired(): boolean {
    if (
      this.$route.name === 'profile' ||
      this.$route.name === 'profileEdit' ||
      this.$route.name === 'organizationDashboard' ||
      this.$route.name === 'jobList' ||
      this.$route.name === 'organizationConfig' ||
      this.$route.name === 'login' ||
      this.$route.name === 'organizationBasic' ||
      this.$route.name === 'organizationProjects' ||
      this.$route.name === 'organizationMember' ||
      this.$route.name === 'changePlan' ||
      this.$route.name === 'storageConfig' ||
      this.$route.name === 'createAccount' ||
      this.$route.name === 'confirmPassword' ||
      this.$route.name === 'confirmSignUp' ||
      this.$route.name === 'createOrganization' ||
      this.$route.name === 'joinSelect' ||
      this.$route.name === 'projectJoin' ||
      this.$route.name === 'sendConfirmCode' ||
      this.$route.name === 'myDashboard'
    ) {
      return false;
    }
    return true;
  }

  private get project() {
    return vxm.theoryApi.projectsStore.getProject?.results;
  }

  private get organizationId() {
    return vxm.theoryApi.authStore.getCurrentOrganizationId ? vxm.theoryApi.authStore.getCurrentOrganizationId : null;
  }
}
